export function fetchImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = resolve;
    image.onerror = image.onabort = reject;

    image.src = src;
  });
}

export function fetchMultipleImages(srcs) {
  Promise.all(srcs.map(fetchImage));
}
